import { FC } from 'react';
import { Stack } from '../Stack/Stack';
import Loader from '../Loader/Loader';
import styles from './loading-overlay.module.scss';

interface LoadingOverlayProps {
  message?: string;
}

export const LoadingOverlay: FC<LoadingOverlayProps> = ({ message }) => {
  return (
    <div className={styles.overlay}>
      <Stack direction="column" spacing="4" alignItems="center">
        <Loader
          loadingPartColor="#031E50"
          loadingBackSet="#E5E5E5"
          size="75px"
          loaderWidth="5px"
        />
        {message && <div className={styles.message}>{message}</div>}
      </Stack>
    </div>
  );
}; 